module.exports = __webpack_public_path__ + "img/Delete.aa86803c.svg";